import userPermission from './userpermission'

export default {
    userPermission
}